/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component, ComponentProps, createRef } from 'react';
import { TextInput, StyleSheet } from 'react-native';
import { themeColors } from './Constants';

type Props = ComponentProps<typeof TextInput>;

class CodeView extends Component<Props> {
  _ref = createRef<HTMLInputElement>();

  componentDidMount() {
    let textInput = this._ref.current;
    if (textInput) {
      // This is kinda hacky but we need to change the cursor style in a way
      // that is not overridden by the CSS.
      textInput.style.cursor = 'text';
    }
  }

  render() {
    let { style, value, ...otherProps } = this.props;
    return (
      <TextInput
        ref={this._ref as never}
        {...otherProps}
        value={value}
        style={[styles.root, style]}
        onFocus={this._onFocus}
        editable={false}
      />
    );
  }

  _onFocus = (event: any) => {
    let { onFocus } = this.props;
    let node = event.target;
    setTimeout(() => {
      node.setSelectionRange(0, node.value.length);
    }, 30);
    onFocus && onFocus(event);
  };
}

let styles = StyleSheet.create({
  root: {
    backgroundColor: '#eee',
    borderWidth: 1,
    borderColor: themeColors.mediumGrey,
    borderRadius: 2,
    paddingVertical: 6,
    paddingHorizontal: 12,
    lineHeight: 20,
    fontWeight: '500',
  },
});

export default CodeView;
